import {applyFilters} from './filters';
import {Form, formsStore} from '../../../stores/Form';
import {PAGE_LIMIT} from '../consts/pagination';
import {callLinkedActions, handleScreenMessage} from './screen';

export const requestPaginationData = async (
    currentForm: Form,
    top: number,
    offset: number,
    focusRowIndex?: number
) => {
    return await applyFilters({form: currentForm, top, skip: offset, focusRowIndex});
};

export const recordViewPaginationGoTo = async (
    form: Form,
    newFocusRowIndex: number,
    fetchData: boolean,
    offset: number
) => {
    return callLinkedActions(formsStore.currentScreen.checkAndSave, async () => {
        if (fetchData) {
            const res = await requestPaginationData(form, PAGE_LIMIT, offset, newFocusRowIndex);
            return handleScreenMessage(res, {});
        }

        return formsStore.currentScreen.onFieldFocusChange(
            {
                newCellIndex: form.currentColumn.index,
                newRowIndex: newFocusRowIndex,
                level: form.level
            },
            (newCellIndex, nextRowIndex) => {
                form.setCurrentRow(nextRowIndex);
            }
        );
    });
};
